// extracted by mini-css-extract-plugin
export default {"box":"DeliveredStatusView_box__xHtaw","talk":"DeliveredStatusView_talk__0gTc8","button":"DeliveredStatusView_button__CuKN2"};